/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModReservations: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.50018 9C6.98518 9 9.00018 6.985 9.00018 4.5C9.00018 2.015 6.98518 0 4.50018 0C2.01418 0 0.000183105 2.015 0.000183105 4.5C0.000183105 6.985 2.01418 9 4.50018 9ZM2.00018 5H0.949183V6H2.29918C2.86218 7.18 4.05518 8 5.44918 8C5.93918 8 6.40418 7.897 6.82818 7.716L6.43318 6.797C6.13118 6.927 5.79918 7 5.44918 7C4.63618 7 3.91918 6.604 3.46218 6H4.94918V5H3.00018C2.96718 4.838 2.94918 4.671 2.94918 4.5C2.94918 4.329 2.96718 4.162 3.00018 4H4.94918V3H3.46218C3.91918 2.396 4.63618 2 5.44918 2C5.79918 2 6.13118 2.073 6.43318 2.203L6.82818 1.284C6.40418 1.103 5.93918 1 5.44918 1C4.05518 1 2.86218 1.82 2.29918 3H0.949183V4H2.00018C1.99776 4.01666 1.99531 4.0333 1.99285 4.04994C1.97101 4.19818 1.94918 4.34626 1.94918 4.5C1.94918 4.65374 1.97101 4.80182 1.99285 4.95006C1.99531 4.9667 1.99776 4.98334 2.00018 5Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 8H14.787C14.457 6.831 13.749 5.823 12.804 5.11C12.818 4.381 13.237 3.691 13.711 3.149C13.992 2.827 13.674 2.336 13.268 2.471C12.478 2.732 11.582 3.105 10.928 3.586C10.971 3.885 11 4.188 11 4.5C11 8.09 8.08998 11 4.49998 11C3.22498 11 2.03898 10.627 1.03498 9.992C1.20698 11.916 2.35898 13.556 3.99998 14.395V15C3.99998 15.553 4.44698 16 4.99998 16H5.99998C6.55298 16 6.99998 15.553 6.99998 15H8.99998C8.99998 15.553 9.44698 16 9.99998 16H11C11.553 16 12 15.553 12 15V14.395C13.346 13.706 14.368 12.481 14.787 11H15C15.553 11 16 10.553 16 10V9C16 8.447 15.553 8 15 8ZM12.5 8C12.224 8 12 7.776 12 7.5C12 7.224 12.224 7 12.5 7C12.776 7 13 7.224 13 7.5C13 7.776 12.776 8 12.5 8Z'
			/>
		</Svg>
	);
};

export { ModReservations };
